import { userConstants } from "../../constant";

const initialState = {
  offer: null,
  loading: false,
  error: null,
};

export function revenueShare(state = initialState, action) {
  switch (action.type) {
    case userConstants.GET_REVENUE_SHARE_OFFER:
      return { ...state, offer: action.offer, loading: false, error: null };
    case userConstants.CREATE_REVENUE_SHARE_OFFER:
      return { ...state, offer: action.offer, loading: false, error: null };
    case userConstants.UPDATE_REVENUE_SHARE_OFFER:
      return { ...state, offer: action.offer, loading: false, error: null };
    default:
      return state;
  }
}
